'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNiceTickValues = require('./getNiceTickValues');

Object.defineProperty(exports, 'getTickValues', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValues;
  }
});
Object.defineProperty(exports, 'getNiceTickValues', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getNiceTickValues;
  }
});
Object.defineProperty(exports, 'getTickValuesFixedDomain', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValuesFixedDomain;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/recharts-scale/lib/index.js
// module id = 846
// module chunks = 0